import React from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconBaseProps, IconRender } from '../types.ts';

const Compliance = React.forwardRef<SVGSVGElement | null, IconBaseProps>(function Compliance({ dataTestId, ...props }, ref) {
  const iconRender = useCallbackRef<IconRender>((color: string) => (
    <>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.1768 3.17677C10.3721 3.37203 10.3721 3.68862 10.1768 3.88388L6.88394 7.17677C6.39579 7.66493 5.60433 7.66493 5.11617 7.17677L3.32328 5.38388C3.12802 5.18862 3.12802 4.87203 3.32328 4.67677L3.67683 4.32322C3.8721 4.12796 4.18868 4.12796 4.38394 4.32322L6.00006 5.93934L9.11617 2.82322C9.31144 2.62796 9.62802 2.62796 9.82328 2.82322L10.1768 3.17677Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M21.0001 5.75C21.0001 6.02614 20.7762 6.25 20.5001 6.25H11.5001C11.2239 6.25 11.0001 6.02614 11.0001 5.75V5.25C11.0001 4.97385 11.2239 4.75 11.5001 4.75H20.5001C20.7762 4.75 21.0001 4.97385 21.0001 5.25V5.75Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.1768 10.1768C10.3721 10.372 10.3721 10.6886 10.1768 10.8839L6.88394 14.1768C6.39579 14.6649 5.60433 14.6649 5.11617 14.1768L3.32328 12.3839C3.12802 12.1886 3.12802 11.872 3.32328 11.6768L3.67683 11.3232C3.8721 11.128 4.18868 11.128 4.38394 11.3232L6.00006 12.9393L9.11617 9.82322C9.31144 9.62796 9.62802 9.62796 9.82328 9.82322L10.1768 10.1768Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M21.0001 12.75C21.0001 13.0261 20.7762 13.25 20.5001 13.25H11.5001C11.2239 13.25 11.0001 13.0261 11.0001 12.75V12.25C11.0001 11.9739 11.2239 11.75 11.5001 11.75H20.5001C20.7762 11.75 21.0001 11.9739 21.0001 12.25V12.75Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.1768 17.1768C10.3721 17.372 10.3721 17.6886 10.1768 17.8839L6.88394 21.1768C6.39579 21.6649 5.60433 21.6649 5.11617 21.1768L3.32328 19.3839C3.12802 19.1886 3.12802 18.872 3.32328 18.6768L3.67683 18.3232C3.8721 18.128 4.18868 18.128 4.38394 18.3232L6.00006 19.9393L9.11617 16.8232C9.31144 16.628 9.62802 16.628 9.82328 16.8232L10.1768 17.1768Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M21.0001 19.75C21.0001 20.0261 20.7762 20.25 20.5001 20.25H11.5001C11.2239 20.25 11.0001 20.0261 11.0001 19.75V19.25C11.0001 18.9739 11.2239 18.75 11.5001 18.75H20.5001C20.7762 18.75 21.0001 18.9739 21.0001 19.25V19.75Z'
        fill={color}
      />
    </>
  ));
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'compliance-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Compliance;
